<template>
    <div class="col-md-12">
        <div class="col-md-12 mt-20">
            <div class="col-md-12 row">
                <div class="col-md-9">
                    <h3 class="page-header">
                        <i class="fa fa fa-building animated bounceInDown show-info" style="font-size: 24px;"></i>
                        Real Estate Sub Category
                    </h3>
                </div>
            </div>
        </div>
        <div>
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-4">
                        <label>Sub Category</label>
                        <input type="text" class="form-control" v-model="subcategoryname" />
                    </div>
                    <div class="col-md-3 mt5">
                        <button class="btn btn-success mt-20" @click="addSubCategory()">Save</button>
                        <button class="btn btn-danger mt-20 ml-5" @click="cancel()">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 mt-10">
            <table class="table">
                <thead>
                    <th>#</th>
                    <th>Category Name</th>
                    <th>Action</th>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in propertysubcategories" :key="item.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.subcategoryname }}</td>
                        <td>
                            <button class="btn btn-primary btn-sm" @click="editFun(item)"> Edit</button>
                            <button class="btn btn-danger btn-sm" @click="rolledbackFun(item)"> Delete</button>
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>
<script>
import axios from 'axios'
import Constants from '../../components/utilities/Constants.vue';

export default {
    mixins: [Constants],
    data() {
        return {
            subcategoryname: '',
            searchtext: '',
            propertysubcategories: [],
            id: 0,
        }
    },
    mounted() {
        this.fetchSubCategory()
    },
    computed: {

    },
    methods: {
        addSubCategory() {
            if (this.subcategoryname !== '') {
                let param = { id: this.id, subcategoryname: this.subcategoryname }
                axios.post('api/realestate/subcategory/create', param)
                    .then(response => {
                        if (response.data.status)
                            this.cancel()
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        },
        editFun(item) {
            this.id = item.id
            this.subcategoryname = item.subcategoryname
        },
        fetchSubCategory() {
            let param = { subcategoryname: this.searchtext }
            axios.post('api/realestate/subcategory/list', param)
                .then(response => {
                    this.propertysubcategories = response.data.propertysubcategories
                })
                .catch(error => {
                    console.log(error)
                })
        },
        rolledbackFun(item) {
            if (confirm('Are you sure you want to delete it.')) {
                let param = { id: item.id }
                axios.post('api/realestate/subcategory/delete', param)
                    .then(response => {
                        if (response.data.status)
                            this.cancel()
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }

        },
        cancel() {
            this.id = 0
            this.subcategoryname = ''
            this.fetchSubCategory()
        }


    },
}
</script>